import React, { useEffect } from 'react';
import {
   TitleBar,
   CustomCardBody,
   CustomNav,
   CustomNavItem,
   CustomNavLink,
} from '../../../../styledComponents/styledComponents';
import { Panel } from '../Styles';
import { TabPane, TabContent } from 'reactstrap';
import StreamSearch from './StreamSearch';
import { SEARCH_TYPE } from '../constants';
import {
   troubleIngestModeSelector,
   troubleModeSelector,
   troubleSyncSettingsSelector,
} from '../../../../redux/selectors/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { E2E, INGEST_MODE } from '../../../../constants/general';
import { setTroubleshootingIngestMode } from '../../../../redux/actions/general';
import { URL_PARAMS } from '../../../../urlSync/urlParamNames';

function IngestPanel() {
   const dispatch = useDispatch();
   const syncSettings = useSelector(troubleSyncSettingsSelector);
   const ingestMode = useSelector(troubleIngestModeSelector);

   const mode = useSelector(troubleModeSelector);

   useEffect(() => {
      if (syncSettings.syncStart !== '')
         dispatch(setTroubleshootingIngestMode(INGEST_MODE.PUBLISH, { [URL_PARAMS.TROUBLE_INGEST_MODE]: INGEST_MODE.PUBLISH }));
   }, [syncSettings, dispatch]);

   return (
      <>
         <Panel>
            <CustomCardBody>
               <TitleBar>Ingest</TitleBar>
               <CustomNav fill={mode === E2E} pills={true}>
                  <CustomNavItem mode={mode}>
                     <CustomNavLink
                        active={ingestMode === INGEST_MODE.PUBLISH}
                        onClick={() =>
                           dispatch(
                              setTroubleshootingIngestMode(INGEST_MODE.PUBLISH, {
                                 [URL_PARAMS.TROUBLE_INGEST_MODE]: INGEST_MODE.PUBLISH,
                              }),
                           )
                        }
                        mode={mode}
                     >
                        Publishes
                     </CustomNavLink>
                  </CustomNavItem>
                  <CustomNavItem mode={mode}>
                     <CustomNavLink
                        active={ingestMode === INGEST_MODE.ALERT}
                        onClick={() =>
                           dispatch(
                              setTroubleshootingIngestMode(INGEST_MODE.ALERT, { [URL_PARAMS.TROUBLE_INGEST_MODE]: INGEST_MODE.ALERT }),
                           )
                        }
                        mode={mode}
                     >
                        Alerts
                     </CustomNavLink>
                  </CustomNavItem>
               </CustomNav>
               <TabContent activeTab={ingestMode}>
                  {ingestMode === INGEST_MODE.PUBLISH ? (
                     <TabPane tabId={INGEST_MODE.PUBLISH}>
                        <StreamSearch searchType={SEARCH_TYPE.PUBLISH} />
                     </TabPane>
                  ) : (
                     <TabPane tabId={INGEST_MODE.ALERT}>
                        <StreamSearch searchType={SEARCH_TYPE.ALERT} />
                     </TabPane>
                  )}
               </TabContent>
            </CustomCardBody>
         </Panel>
      </>
   );
}

export default IngestPanel;
